<template>
  <div id="main" v-loading="loading">
    <div class="banner">
      <div class="lunbo">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
              <!-- <img class="banner_img" :src="item.imageUrl" alt="" srcset=""> -->
              <div class="banner_img">
                <el-image :src="item.imageUrl" fit="cover" style="width: 100%;height: 100%;">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
          <!-- 如果需要导航按钮 -->
          <!-- <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div> -->

          <!-- 如果需要滚动条 -->
          <div class="swiper-scrollbar"></div>
        </div>
      </div>
    </div>
    <!-- 课程 -->
    <div class="ks_main w">
      <div class="kc_warp">
        <div class="k-flx clearfix mt30">
          <div class="label-box">
            <img src="@/assets/img/zuixinkecheng.png" alt="最新课程">
          </div>
          <div class="look-more">
            <router-link class="txt" to="/course">More+</router-link>
          </div>
        </div>
        <div class="kc_box mt20 clearfix">
          <div style="display: flex;" v-if="newCourse.length <= 0">
            <el-skeleton style="width: 24.1%;" v-for="i in 4">
              <template slot="template">
                <el-skeleton-item variant="image" style="width: 240px; height: 240px;" />
                <div style="padding: 14px;">
                  <el-skeleton-item variant="p" style="width: 50%" />
                  <div style="display: flex; align-items: center; justify-items: space-between;">
                    <el-skeleton-item variant="text" style="margin-right: 16px;" />
                    <el-skeleton-item variant="text" style="width: 30%;" />
                  </div>
                </div>
              </template>
            </el-skeleton>
          </div>
          <div class="kc_item" @click="jumpDetail(item)" v-for="(item, index) in newCourse" :key="item.id">
            <!-- <img :src="item.mainImg" alt="课程"> -->
            <div class="img">
              <el-image :src="item.mainImg" fit="cover" style="width: 100%;height: 100%;">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="info_box">
              <h4 class="qoverDot2">{{ item.title }}</h4>
              <div class="lecturer">
                <span class="name">主讲人：{{ item.teacherName }}</span>
                <span>学时：{{ item.learnHour }}</span>
              </div>
              <div class="view_num"><i class="icon el-icon-view"></i>{{ item.viewNum }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="kc_warp">
        <div class="k-flx clearfix mt30">
          <div class="label-box">
            <img src="@/assets/img/zuirekecheng.png" alt="最热课程">
          </div>
          <div class="look-more">
            <router-link class="txt" to="/course">More+</router-link>
          </div>
        </div>
        <div class="kc_box mt20 clearfix">
          <div style="display: flex;" v-if="rankCourse.length <= 0">
            <el-skeleton style="width: 24.1%;" v-for="i in 4">
              <template slot="template">
                <el-skeleton-item variant="image" style="width: 240px; height: 240px;" />
                <div style="padding: 14px;">
                  <el-skeleton-item variant="p" style="width: 50%" />
                  <div style="display: flex; align-items: center; justify-items: space-between;">
                    <el-skeleton-item variant="text" style="margin-right: 16px;" />
                    <el-skeleton-item variant="text" style="width: 30%;" />
                  </div>
                </div>
              </template>
            </el-skeleton>
          </div>
          <div class="kc_item" @click="jumpDetail(item)" v-for="(item, index) in rankCourse" :key="item.id">
            <!-- <img :src="item.mainImg" alt="课程"> -->
            <div class="img">
              <el-image :src="item.mainImg" fit="cover" style="width: 100%;height: 100%;">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div class="info_box">
              <h4 class="qoverDot2">{{ item.title }}</h4>
              <div class="lecturer">
                <span class="name">主讲人：{{ item.teacherName }}</span>
                <span>学时：{{ item.learnHour }}</span>
              </div>
              <div class="view_num"><i class="icon el-icon-view"></i>{{ item.viewNum }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 排行榜 -->
    <div class="list_top clearfix w">
      <div class="list_item">
        <div class="ls_flx">
          <img src="@/assets/img/tongzhigonggao.png" alt="通知公告">
        </div>
        <div class="ls_warp tz">
          <router-link :to="'/announcementDetail?did=' + item.id" v-for="(item, index) in noticeList" :key="item.id">
            <div class="row clearfix">
              <div class="con">
                <h4> {{ item.title }}</h4>
                <div class="time">{{ item.createTime }}</div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="list_item">
        <div class="ls_flx">
          <img src="@/assets/img/remenpaihang.png" alt="热门课程排行榜">
        </div>
        <div class="ls_warp other">
          <div style="cursor: pointer;" @click="jumpDetail(item)" v-for="(item, index) in rankCourse" :key="item.id">
            <div class="row flex">
              <div class="con flex">
                <em class="topNum">{{ index + 1 }}</em>
                <h4> {{ item.title }}</h4>
              </div>
              <div class="s_num"><span class="red">{{ item.viewNum }}人</span> 已学</div>
            </div>
          </div>
        </div>
      </div>
      <div class="list_item">
        <div class="ls_flx">
          <img src="@/assets/img/guankanshichang.png" alt="观看时长排行榜">
        </div>
        <div class="ls_warp other">
          <router-link to="#">
            <div class="row flex" v-for="(item, index) in timeRankList" :key="index">
              <div class="con flex">
                <em class="topNum">{{ index + 1 }}</em>
                <div class="user">
                  <!-- <img :src="item.avatar" alt="头像"> -->
                  <div class="img">
                    <el-image :src="item.avatar" fit="cover" style="width: 100%;height: 100%;border-radius: 50%;">
                      <div slot="error" class="image-slot" style="font-size: 20px;">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                  <div class="user-name">{{ item.nickname }}</div>
                </div>
              </div>
              <div class="s_num"><span class="red">{{ item.learnHour }}</span> 学时</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 底部 数据 -->
    <div class="data_box w flex">
      <div class="data_item">
        <img src="@/assets/img/icon_zhucerenshu.png" alt="注册人数">
        <div class="flex">
          <div class="txt">注册人数</div>
          <div class="num">{{ webInfo.registerNum }}</div>
        </div>
      </div>
      <div class="data_item">
        <img src="@/assets/img/icon_zaixianrenshuo.png" alt="课程解锁数量">
        <div class="flex">
          <div class="txt">课程解锁数量</div>
          <div class="num">{{ webInfo.studyNum }}</div>
        </div>
      </div>
      <div class="data_item">
        <img src="@/assets/img/icon_kejianshuliang.png" alt="课程数量">
        <div class="flex">
          <div class="txt">课程数量</div>
          <div class="num">{{ webInfo.courseNum }}</div>
        </div>
      </div>
      <div class="data_item">
        <img src="@/assets/img/icon_fangwenrenshuo.png" alt="访问人次">
        <div class="flex">
          <div class="txt">访问人次</div>
          <div class="num">{{ webInfo.accessNum }}</div>
        </div>
      </div>
    </div>
    <el-dialog style="font-size: 14px;" title="提示" @closed="closed" :visible.sync="centerDialogVisible" width="30%"
      center>
      <p>温馨提示：输入兑换码点击确定即可参加培训</p>
      <el-form ref="form" :rules="rules" :model="form">
        <el-form-item label="兑换码">
          <el-input v-model="form.code" placeholder="请输入课程兑换码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="bindCodeFun">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import Swiper from "swiper"
import { bannerApi, getCourseNew, getCourseRanking, getNotice, getRanking, getWebInfo, accessRecord } from "@/api/home";
import { unlockCourse, courseCheck } from "@/api/course";
import { bindCode } from "@/api/user";
import { mapState, mapActions } from "vuex";
var that;
export default {
  name: 'HomeView',
  computed: mapState(['user', 'hasLogin', 'webInfo']),
  data() {
    return {
      loading: false,
      form: {
        courseId: '',
        code: ''
      },
      centerDialogVisible: false,
      bannerList: [],
      mySwiper: null,
      newCourse: [],
      rankCourse: [],
      noticeList: [],
      timeRankList: [],
      rules: {
        code: [{ required: true, trigger: 'blur', message: '兑换码不可为空' }]
      }
    };
  },
  mounted() {
    that = this;
    this.initSwiper();
    this.loadBanner();
    this.loadCours();
    this.loadNotice();
    accessRecord().then(res => {
      console.log("访问了");
    })
  },
  methods: {
    closed() {
      this.form.courseId = '';
      this.form.code = '';
    },
    bindCodeFun() {
      if (!this.hasLogin) {
        this.$router.push('/login');
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          unlockCourse(this.form).then(res => {
            if (res.code == 200) {
              this.loadCours();
              this.$message.success('课程兑换成功')
              this.centerDialogVisible = false;
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })

    },
    // 跳转详情
    jumpDetail(item) {
      if (!this.hasLogin) {
        this.$router.push('/login');
        return;
      }
      courseCheck({
        courseId: item.id
      }).then(res => {
        if (res.code == 200) {
          if (res.data) {
            this.$router.push(`/course-detail?did=${item.id}`)
          } else {
            this.form.courseId = item.id;
            this.centerDialogVisible = true;
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 加载通知
    loadNotice() {
      getNotice({
        pageNum: 1,
        pageSize: 10
      }).then(res => {
        this.noticeList = res.data;
      })
      // 观看时长
      getRanking({
        pageNum: 1,
        pageSize: 10
      }).then(res => {
        this.timeRankList = res.data;
      })
    },
    // 加载课程
    loadCours() {
      this.loading = true;
      getCourseNew({
        pageNum: 1,
        pageSize: 8
      }).then(res => {
        this.newCourse = res.data;
      })
      getCourseRanking({
        pageNum: 1,
        pageSize: 8
      }).then(res => {
        this.loading = false;
        this.rankCourse = res.data;
      }).catch(err => {
        this.loading = false;
      })
    },
    // 加载轮播图
    loadBanner() {
      bannerApi().then(res => {
        this.bannerList = res.data;
        setTimeout(() => {
          this.mySwiper.update()
        }, 500)
      })
    },
    initSwiper() {
      that.mySwiper = new Swiper('.swiper-container', {
        //direction: 'vertical', // 垂直切换选项
        //mousewheel: true, //滚轮
        autoplay: false,
        height: 554,
        // width: window.innerWidth,
        loop: true, // 循环模式选项

        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true, // 分页器可以点击
        },

        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.arrow-right',
          prevEl: '.arrow-left',
        },
        on: {
          resize: function () {
            setTimeout(() => {
              that.mySwiper.update()
            }, 100)
          },
        },
      });
    }
  },
}
</script>
<style lang="scss" scoped>
#main {
  width: 100%;
}

.banner {
  width: 100%;

  .lunbo {
    width: 100%;

    .swiper-container {
      width: 100%;
    }

    .banner_img {
      width: 100%;
      height: 660px;
      background-size: 100% 100%;
      object-fit: cover;
    }
  }
}



.list_top {
  width: 100%;
  margin-bottom: 60px;

  .list_item {
    text-align: left;
    width: 32.66%;
    float: left;
    margin-right: 1%;

    .ls_warp {
      min-height: 450px;
    }

    .ls_flx {
      height: 71px;
      border-bottom: 1px solid #CD2312;
    }

    .tz {
      padding: 16px;
      box-sizing: border-box;
      background-color: #fff;

      .row {
        position: relative;
        margin-bottom: 20px;

        .con {
          position: relative;
          display: inline-block;
          padding-left: 10px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;

          .time {
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
          }

          &::after {
            content: '';
            position: absolute;
            left: 0;
            top: 6px;
            width: 6px;
            height: 6px;
            border-radius: 3px;
            background: #CD2312;
          }
        }
      }


    }

    .other {
      background-color: #fff;
      padding: 26px 13px;

      .row {
        width: 100%;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;

        .s_num {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          margin-left: 54px;

          .red {
            color: #CD2312;
          }
        }


        .con {
          flex: 1;
          position: relative;
          align-items: center;

          h4 {
            font-size: 14px;
            font-weight: 500;
            color: #3D3D3D;
            line-height: 24px;
            margin-left: 21px;
          }

          .topNum {
            font-size: 24px;
            font-family: FZLanTingHeiS-H-GB-Regular, FZLanTingHeiS-H-GB;
            font-weight: 400;
            color: #CCCCCC;
            line-height: 20px;
            font-style: italic;
          }

          .user {
            margin-left: 21px;
            display: flex;
            align-items: center;

            .img {
              width: 48px;
              height: 48px;
              border-radius: 50%;
              object-fit: cover;
            }

            .user-name {
              margin-left: 5px;
              font-size: 14px;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
            }
          }
        }

      }
    }
  }

  &>.list_item:nth-child(3n) {
    margin-right: 0;
  }
}

.data_box {
  text-align: left;
  padding: 60px 60px;
  box-sizing: border-box;
  justify-content: space-between;


  .data_item {
    display: flex;
    align-items: center;

    .flex {
      flex-direction: column;
      justify-content: center;
      margin-left: 24px;

      .txt {
        font-size: 14px;
        font-weight: 400;
        color: #3D3D3D;
        line-height: 20px;
      }

      .num {
        margin-top: 9px;
        font-size: 24px;
        font-weight: 700;
        color: #CD2312;
        line-height: 20px;
      }
    }
  }
}
</style>